import { ApiBind, Common } from './common.model';

export class ChangePassword extends Common {

  @ApiBind({ column: 'new_password' })
  newPassword: string;

  @ApiBind({ column: 'confirmation_password' })
  confirmationPassword: string;

}
